import ImageCard from "../ImageCard/ImageCard.jsx"
import css from "./ImageGallery.module.css"

export default function ImageGallery({ images, onImageClick }) {
  return (
    <ul className={css.gallery}>
      {images.map((image) => (
        <li key={image.id}>
          <ImageCard image={image} onImageClick={onImageClick} />
        </li>
      ))}
    </ul>
  )
}